import React, { useState, useEffect } from 'react'
import axios from './axios'
// but we can use the name instance on the above import instead of axios.
import './Row.css'
import movieTrailer from 'movie-trailer'
import ReactPlayer from 'react-player'

const base_url = "https://image.tmdb.org/t/p/original/";

function Row({title, fetchUrl, isLargeRow}) {

    const [movies, setMovies] = useState([]);
    const [trailerUrl, setTrailerUrl] = useState("");

    useEffect(() => {
        async function fetchData() {
            const request = await axios.get(fetchUrl)
            setMovies(request.data.results)
            return request;
        }
        fetchData();
    }, [fetchUrl])

 

    function handleClick (movie) {
        if (trailerUrl) {
            setTrailerUrl("")
        } else {
            movieTrailer(movie?.title || movie?.original_name || movie?.name || movie?.original_title || "")
            .then ((url) => {
                const urlParams = new URLSearchParams(new URL(url).search);
                    setTrailerUrl(urlParams.get('v'))
                }).catch((error) => console.log(error));
        } 
    }

  return (
    <div className="row">

        <h2>{title}</h2>
        
        <div className="row__posters">
            {movies && movies.map(movie => (
                <img onClick={() => handleClick(movie)} key={movie.id} src={`${base_url}${isLargeRow ? movie.poster_path : movie.backdrop_path}`} alt={movie.original_title} className={`row__poster ${isLargeRow && "row__posterLarge"}`} />   
            ))}
        </div>
       
        { trailerUrl && <ReactPlayer url={`https://www.youtube.com/watch?v=${trailerUrl}`} className="reactPlayer" controls={true} loop={true} /> }

    </div>
  )
}

export default Row;